/**
 * Endkundenrechner API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { KundeLoginRequest } from '../model/kunde-login-request.model';
// @ts-ignore
import { KundeLoginResponse } from '../model/kunde-login-response.model';
// @ts-ignore
import { StartKundeTaskRequest } from '../model/start-kunde-task-request.model';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    KundeServiceInterface,
    ExchangeKundeSitzungRequestParams,
    LoginKundeRequestParams,
    StartKundeTaskRequestParams
} from './kunde.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class KundeService extends BaseService implements KundeServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Tauscht den kurzlebigen Zugriff-Token aus dem Aufruf-Link eines Bearbeiters gegen eine Kundensitzung und liefert die beim Partner hinterlegten Personendaten mit. Tritt an die Stelle der Kundenanmeldung, ohne die gespeicherte Berechnung zu lesen.
     * @endpoint post /api/kunde/sitzung
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public exchangeKundeSitzung(requestParameters: ExchangeKundeSitzungRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<KundeLoginResponse>;
    public exchangeKundeSitzung(requestParameters: ExchangeKundeSitzungRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<KundeLoginResponse>>;
    public exchangeKundeSitzung(requestParameters: ExchangeKundeSitzungRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<KundeLoginResponse>>;
    public exchangeKundeSitzung(requestParameters: ExchangeKundeSitzungRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const zugriffToken = requestParameters?.zugriffToken;
        if (zugriffToken === null || zugriffToken === undefined) {
            throw new Error('Required parameter zugriffToken was null or undefined when calling exchangeKundeSitzung.');
        }
        const session = requestParameters?.session;

        let localVarHeaders = this.defaultHeaders;
        if (zugriffToken !== undefined && zugriffToken !== null) {
            localVarHeaders = localVarHeaders.set('zugriffToken', String(zugriffToken));
        }
        if (session !== undefined && session !== null) {
            localVarHeaders = localVarHeaders.set('session', String(session));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/kunde/sitzung`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<KundeLoginResponse>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Meldet den Endkunden mit seinen Zugangsdaten beim Partner-Backoffice des Partners an, bindet ihn an seine gespeicherte Berechnung und liefert ein Token für die weiteren Aufrufe.
     * @endpoint post /api/kunde/login
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public loginKunde(requestParameters: LoginKundeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<KundeLoginResponse>;
    public loginKunde(requestParameters: LoginKundeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<KundeLoginResponse>>;
    public loginKunde(requestParameters: LoginKundeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<KundeLoginResponse>>;
    public loginKunde(requestParameters: LoginKundeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const session = requestParameters?.session;
        const kundeLoginRequest = requestParameters?.kundeLoginRequest;
        if (kundeLoginRequest === null || kundeLoginRequest === undefined) {
            throw new Error('Required parameter kundeLoginRequest was null or undefined when calling loginKunde.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (session !== undefined && session !== null) {
            localVarHeaders = localVarHeaders.set('session', String(session));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/kunde/login`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<KundeLoginResponse>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: kundeLoginRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Eröffnet für den angemeldeten Kunden eine neue, leere Berechnung und bindet die Kundensitzung an sie. Für den Start einer weiteren Berechnung mit vorhandenem Kunde-Token; die Anmeldung selbst legt ihre Berechnung weiterhin selbst an. Die beim Partner hinterlegten Personendaten kommen wie bei der Anmeldung zum Vorbefüllen mit. Das absolute Sitzungsfenster läuft unverändert weiter.
     * @endpoint post /api/kunde/task
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public startKundeTask(requestParameters: StartKundeTaskRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<KundeLoginResponse>;
    public startKundeTask(requestParameters: StartKundeTaskRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<KundeLoginResponse>>;
    public startKundeTask(requestParameters: StartKundeTaskRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<KundeLoginResponse>>;
    public startKundeTask(requestParameters: StartKundeTaskRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kundeToken = requestParameters?.kundeToken;
        if (kundeToken === null || kundeToken === undefined) {
            throw new Error('Required parameter kundeToken was null or undefined when calling startKundeTask.');
        }
        const session = requestParameters?.session;
        const startKundeTaskRequest = requestParameters?.startKundeTaskRequest;
        if (startKundeTaskRequest === null || startKundeTaskRequest === undefined) {
            throw new Error('Required parameter startKundeTaskRequest was null or undefined when calling startKundeTask.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (kundeToken !== undefined && kundeToken !== null) {
            localVarHeaders = localVarHeaders.set('kundeToken', String(kundeToken));
        }
        if (session !== undefined && session !== null) {
            localVarHeaders = localVarHeaders.set('session', String(session));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/kunde/task`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<KundeLoginResponse>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: startKundeTaskRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
